export default __webpack_public_path__ + "static/media/Others_1.34be6f58.svg";